module.exports = __webpack_public_path__ + "static/media/addexistingregistry_379x180_v2.a5dd5a2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/addexistingregistry_379x180_v2.jpg
// module id = 551
// module chunks = 40